import LazyLoad from "vanilla-lazyload/dist/lazyload";


/* eslint-disable camelcase */

export default function() {

    function lazyLoadPolyfill() {

        $('iframe[data-src]').each(function() {
            $(this).attr('src', $(this).attr('data-src'));
        });
    }

    try {
        return new LazyLoad({
            elements_selector: "iframe",
            class_loading: "lazy-load-iframe--loading",
            class_loaded: "lazy-load-iframe--loaded",
            class_initial: "lazy-load-iframe--initial",
            data_src: "src",
        });
    } catch(e) {
        lazyLoadPolyfill();
    }
}



// WEBPACK FOOTER //
// ./js/lazy-load/IframeLazyLoad.js